.categories {
  margin-bottom: 0.5em;
}

.categoryRow {
  height: 3.5em;

  &:nth-of-type(2n+1) {
    background-color: var(--lightSilver);
  }
}

.categoryValue {
  min-width: 2.5em;
}

.categoryValueSeparator {
  width: 0.5em;
}

.categoryValueInput {
  width: 4.5em;
}

.categoryDescription {
  padding-right: 0.2em;
  padding-left: 0.2em;
}

.removeCategory {
  width: 3em;
}
